module.exports = __webpack_public_path__ + "img/magnifying_glass_and_book.b9d1b01a.jpg";